export default {
  install(Vue, { store }) {
    Vue.prototype.$snackbar = contents => {
      store.dispatch('components/snackbar/setContents', contents);
    };
  },
};
